import React from "react";
import { ReactElement } from "react"

export function TabContainer(props: {
	children: ReactElement[],

	initialIndex?: number,

	displayStyle?: "enclose" | "border" | "border-indent",

	onChange?: (index: number) => void,
}) {
	const [activeTab, setActiveTab] = React.useState(props.initialIndex ? props.initialIndex : 0);

	const contents = props.children[activeTab];
	const activeProps = contents.props;

	return (
		<div className="tab-container">
			<div className="tab-buttons flex gap-1">
				{
					props.children.map((c, i) => {
						return (
							<button
								key={i}
								className={
									"tab-button " + ((i === activeTab) ? "active primary " : "secondary ") + c.props.className
									+ (c.props.hidden ? " hidden" : "")
								}
								onClick={() => {
									setActiveTab(i);
									if (props.onChange) props.onChange(i);
								}}
							>{c.props.title}</button>
						);
					})
				}
			</div>

			<div className={"tab-contents " + (props.displayStyle ? props.displayStyle : "")}>
				{contents}
			</div>
		</div>
	)
}


export function Tab(props: {
	title: any,

	className?: string,

	hidden?: boolean,

	children?: any,
}) {
	return (
		// <div className={props.className + (props.hidden ? "hidden" : "")}>
			props.children
		// </div>
	)
}